import { ArchivalAidMetadata, EadNode } from 'types';
import { separatorJoin, SeparatorJoinItem } from 'utils/separatorJoin';

type Props = {
  archivalAidMetadata?: ArchivalAidMetadata;
  eadNode: EadNode;
};

export const generateEadQuote = ({ archivalAidMetadata, eadNode }: Props) => {
  const collectionName = archivalAidMetadata?.archivalCollection?.name;

  const summary = eadNode.publicCopy?.summary;
  const timeRange = eadNode.publicCopy?.timeRange;

  const quoteSections: SeparatorJoinItem[] = [
    ['Archiv Univerzity Karlovy', '; '],
    collectionName ? `fond ${collectionName}` : undefined,
    `referenční označení ${eadNode.referenceId}`,
    summary,
    timeRange,
  ];

  return `${separatorJoin(quoteSections, ', ')}.`;
};
